import { api } from "./api";

const readyStates = new Set(["ready", "completed", "uploaded"]);
const failedStates = new Set(["failed", "error", "rejected"]);

function uploadToUrl(url: string, file: File, headers: Record<string, string>) {
  return new Promise<void>((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.open("PUT", url);
    for (const [name, value] of Object.entries(headers)) request.setRequestHeader(name, value);
    request.onload = () => request.status >= 200 && request.status < 300 ? resolve() : reject(new Error("The image did not upload."));
    request.onerror = () => reject(new Error("The image did not upload."));
    request.send(file);
  });
}

export async function uploadFile(file: File) {
  const slot = await api<{ id?: string; upload_url?: string; upload_headers?: Record<string, string> }>("/api/ads/files", {
    method: "POST",
    body: JSON.stringify({ filename: file.name }),
  });
  if (!slot.id || !slot.upload_url) throw new Error("The image upload could not start.");
  await uploadToUrl(slot.upload_url, file, { "Content-Type": file.type || "application/octet-stream", ...(slot.upload_headers || {}) });
  for (let attempt = 0; attempt < 60; attempt += 1) {
    if (attempt > 0) await new Promise((resolve) => window.setTimeout(resolve, 1_000));
    const current = await api<Record<string, unknown>>(`/api/ads/files/${encodeURIComponent(slot.id)}`);
    const status = String(current.upload_status || current.status || "").toLowerCase();
    if (readyStates.has(status)) return { ...current, id: slot.id, name: file.name };
    if (failedStates.has(status)) throw new Error("The image could not be processed. Choose another image.");
  }
  throw new Error("The image is still processing. Try again in a moment.");
}
